import { formatDateRange, formatSingleDate } from 'utilities/calendarFunctions';
import { Button } from 'pageFramework/uiControls/buttons';
import { CalendarDatePicker } from 'pageFramework/uiControls/inputs';
import { PreviousIcon, NextIcon } from 'pageFramework/uiControls/icons';
import React from 'react';

interface ScheduleDayToolbarProps {
	close: () => void;
	startDate?: string;
	endDate?: string;
	onPreviousDay: (date: string) => void;
	onNextDay: (date: string) => void;
	onTodayClick: () => void;
	handleDateSelect: (date: string) => void;
}

const ScheduleDayToolbar: React.FC<ScheduleDayToolbarProps> = ({
	close,
	startDate = '',
	endDate = '',
	onPreviousDay,
	onNextDay,
	onTodayClick,
	handleDateSelect,
}) => {
	const dateHeading = endDate !== '' ? formatDateRange(startDate, endDate) : formatSingleDate(startDate);

	return (
		<section className="schedule-toolbar">
			<div className="container">
				<div></div>
				<div className="view-controls">
					<div className="btn-group">
						<Button color="secondary" variant="outline" onClick={() => onPreviousDay(startDate)} aria-label="Previous week">
							<PreviousIcon />
						</Button>
						<CalendarDatePicker
							onChange={handleDateSelect}
							dateRangeLabel={dateHeading}
							value={startDate}
							view="day"
							onTodayClick={onTodayClick}
							defaultDate={startDate}
						/>
						<Button color="secondary" variant="outline" onClick={() => onNextDay(startDate)} aria-label="Next week">
							<NextIcon />
						</Button>
					</div>
				</div>
				<div className="controls-align-right">
					<Button color="primary" onClick={close}>
						Week View
					</Button>
				</div>
			</div>
		</section>
	);
};

export default ScheduleDayToolbar;